import React from "react";
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import "./Styles/global.scss";
import Loadable from "react-loadable";
import Loader from "./_helpers/loader";
import ScrollArrow from "./components/Homepage/ScrollToTop";
import Error from "./components/ErrorPage";
import ExhaustedPlanError from "./components/ExhaustedPlanErrorPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";





const Login = Loadable({
  loader: () => import("./components/Login"),
  loading: Loader,
  delay: 100,
});

const Signup = Loadable({
  loader: () => import("./components/Signup"),
  loading: Loader,
  delay: 100,
});

const CreateAccount = Loadable({
  loader: () => import("./components/CreateAccount"),
  loading: Loader,
  delay: 100,
});

const LoginWithEmail = Loadable({
  loader: () => import("./components/LoginWithEmail"),
  loading: Loader,
  delay: 100,
});

// const RequestReset = Loadable({
//   loader: () => import("./components/RequestReset"),
//   loading: Loader,
//   delay: 100,
// });


const ResetPassword = Loadable({
  loader: () => import("./components/ResetPassword"),
  loading: Loader,
  delay: 100,
});

const NewPassword = Loadable({
  loader: () => import("./components/Lift/LiftUserAuthManagement/NewPassword"),
  loading: Loader,
  delay: 100,
})

const LiftEmailConfirmation = Loadable({
  loader: () => import("./components/Lift/LiftUserAuthManagement/EmailConfirmation/LiftEmailConfirmation"),
  loading: Loader,
  delay: 100,
});

const Dashboard = Loadable({
  loader: () => import("./components/Dashboard"),
  loading: Loader,
  delay: 100,
});

// const HomePage = Loadable({
//   loader: () => import("./components/Homepage/HomePage"),
//   loading: Loader,
//   delay: 100,
// });

const Lift = Loadable({
  loader: () => import("./components/Lift/Lift"),
  loading: Loader,
  delay: 100,
});


const CurrencyModal = Loadable({
  loader: () => import("./components/Lift/CurrencyModal"),
  loading: Loader,
  delay: 100,
});



const LiftHistory = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/History/History"),
  loading: Loader,
  delay: 100,
});


const InfoExchangeForm = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/InfoExchangeForm"),
  loading: Loader,
  delay: 100,
});



const LiftDiscount = Loadable({
  loader: () => import("./components/Lift/Lift-Discount/Lift-Discount"),
  loading: Loader,
  delay: 100,
});

const LiftLead = Loadable({
  loader: () => import("./components/Lift/Lift-Lead/LiftLead"),
  loading: Loader,
  delay: 100,
});

const LiftDiamondPlanFormSuccess = Loadable({
  loader: () =>
    import("./components/Lift/Lift-Lead/diamondPlanFormFolder/DiamondPlanFormSuccess"),
  loading: Loader,
  delay: 100,
});

const LiftDiamondPlanForm = Loadable({
  loader: () =>
    import("./components/Lift/Lift-Lead/DiamondPlanForm"),
  loading: Loader,
  delay: 100,
});

const SignupSuccessPage = Loadable({
  loader: () => import("./components/SignupSuccessPage"),
  loading: Loader,
  delay: 100,
});

const TermsPage = Loadable({
  loader: () => import("./components/TermsPage"),
  loading: Loader,
  delay: 100,
});

const LiftBookInfoPage = Loadable({
  loader: () => import("./components/Lift/Lift-Lead/BookInfoPage"),
  loading: Loader,
  delay: 100,
});

const LiftBookInfoPage_B = Loadable({
  loader: () => import("./components/Lift/Lift-Lead/BookInfoPage_B"),
  loading: Loader,
  delay: 100,
});

const LiftCompleteBookDownloadPromptPage = Loadable({
  loader: () =>
    import("./components/Lift/Lift-Lead/CompleteBookDownloadPromptPage"),
  loading: Loader,
  delay: 100,
});

const LiftPricingStandalonePage = Loadable({
  loader: () => import("./components/Lift/PricingStandalonePage"),
  loading: Loader,
  delay: 100,
});


const PricingForDashboard = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/PricingForDashboard"),
  loading: Loader,
  delay: 100,
});

const WhatWeDoStandalonePage = Loadable({
  loader: () => import("./components/Lift/WhatWeDoStandalonePage"),
  loading: Loader,
  delay: 100,
});

const LiftSubscriptionRegistration = Loadable({
  loader: () => import("./components/Lift/Lift-Lead/SubscriptionRegistration"),
  loading: Loader,
  delay: 100,
});

const LiftPaymentSuccessPage = Loadable({
  loader: () => import("./components/Lift/Lift-Lead/PaymentSuccessPage"),
  loading: Loader,
  delay: 100,
});

const LiftBookDownloadSuccessPage = Loadable({
  loader: () => import("./components/Lift/Lift-Lead/BookDownloadSuccessPage"),
  loading: Loader,
  delay: 100,
});

const LiftReferByEmail = Loadable({
  loader: () => import("./components/Lift/Lift-Lead/ReferByEmail"),
  loading: Loader,
  delay: 100,
});




const ContactUs = Loadable({
  loader: () => import("./components/Homepage/ContactUs"),
  loading: Loader,
  delay: 100,
});

const LiftDashboard = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/LiftDashboard"),
  loading: Loader,
  delay: 100,
});

const SapphireTasks = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/Sapphire/SapphireTasks"),
  loading: Loader,
  delay: 100,
});

const SapphireCompleted = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/Sapphire/SapphireCompletedTasks"),
  loading: Loader,
  delay: 100,
});

const AccountSettings = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/AccountSettings"),
  loading: Loader,
  delay: 100,
});

const LiftLogin = Loadable({
  loader: () => import("./components/Lift/LiftUserAuthManagement/LiftLogin"),
  loading: Loader,
  delay: 100,
});

const LiftCreateAccount = Loadable({
  loader: () => import("./components/Lift/LiftUserAuthManagement/LiftCreateAccount"),
  loading: Loader,
  delay: 100,
});

const TestUi = Loadable({
  loader: () => import("./components/Lift/TestUi"),
  loading: Loader,
  delay: 100,
});


const ViewAllNotificationsTable = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/Notifications/ViewAllNotificationsTable"),
  loading: Loader,
  delay: 100,
});


const CompletePlanPayment = Loadable({
  loader: () => import("./components/Lift/Lift-Dashboard/CompletePlanPayment"),
  loading: Loader,
  delay: 100,
});



const LiftResetPassword = Loadable({
  loader: () => import("./components/Lift/LiftUserAuthManagement/LiftResetPassword"),
  loading: Loader,
  delay: 100,
});

const LiftForgotPassword = Loadable({
  loader: () => import("./components/Lift/LiftUserAuthManagement/ForgotPasswordModal"),
  loading: Loader,
  delay: 100,
});

const LiftFAQ = Loadable({
  loader: () => import("./components/Lift/FAQ-singlePage"),
  loading: Loader,
  delay: 100,
});

const isLoggedIn = () => {
  return localStorage.getItem("TOKEN_KEY") != null;
};

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn() === true ? (
        <Component {...props} />
      ) : (
        <Redirect to="/lift-login" />
      )
    }
  />
);

const App = () => {
  return (
    <BrowserRouter >
      <ToastContainer />
      <div className="app">
        <ScrollArrow />
        <Switch>
          <Route path="/" exact component={Lift} />
          <Route path="/contact-us" exact component={ContactUs} />
          <Route path="/lift" exact component={Lift} />
          <Route path="/login" exact component={Login} />
          <Route path="/signup" component={Signup} />
          <Route path="/create-account" exact component={CreateAccount} />
           {/* <ProtectedRoute path="/dashboard" component={Dashboard} /> */}
           <Route path="/dashboard" component={Dashboard} />





          <Route path="/login-with-email" exact component={LoginWithEmail} />
          <Route path="/reset-password" exact component={ResetPassword} />
          <Route path="/lift-new-password" component={NewPassword} />
          <Route path="/lift-discount" component={LiftDiscount} />
          <Route path="/api/users/confirm" component={LiftEmailConfirmation} />
          <Route path="/lift-lead" component={LiftLead} />
          <Route path="/diamond-plan-form" component={LiftDiamondPlanForm} />
          <Route path="/growth" component={LiftBookInfoPage} />
          <Route path="/growth-book" component={LiftBookInfoPage_B} />
          <Route path="/lift-info-exchange" exact component={InfoExchangeForm} />
          <Route
            path="/complete-book-download"
            component={LiftCompleteBookDownloadPromptPage}
          />
          <Route path="/pricing" component={ LiftPricingStandalonePage } />
          <Route path="/pricing-dashboard" component={ PricingForDashboard } />
          <Route path="/whatwedo" component={WhatWeDoStandalonePage} />
          {/* <Route path="/payment-successful" component={LiftPaymentSuccessPage} /> //replaced with alert */}
          <Route
            path="/book-download-success"
            component={LiftBookDownloadSuccessPage}
          />
          <Route path="/tell-friends" component={LiftReferByEmail} />
          <Route path="/terms-and-conditions" component={TermsPage} />
          <Route path="/lift-login" component={LiftLogin} />
          <Route path="/lift-create-account" component={LiftCreateAccount} />
          {/* <Route path="/request-reset" exact component={RequestReset} /> */}
          <Route
            path="/lift-forgot-password"
            exact
            component={LiftForgotPassword}
          />
          <Route path="/lift-new-password" exact component={LiftResetPassword} />
          <Route path="/subscription-exhausted" component={ExhaustedPlanError} />
          <Route path="/faq" component={LiftFAQ} />
          <Route path="/lift/lift-lead" component={LiftLead} />
          <Route path="/signup-success-page" component={SignupSuccessPage} />
          <Route path="/diamond-plan-success" component={LiftDiamondPlanFormSuccess} />
          <Route path="/complete-subscription" component={CompletePlanPayment} />
          {/* <ProtectedRoute path="subscription-currency" component={CurrencyModal} /> */}
         
          <ProtectedRoute path="/lift-dashboard" component={LiftDashboard} />
          {/* <Route path="/lift-dashboard" component={LiftDashboard}  /> */}
          <Route path="/lift-dashboard/sapphire-task" component={SapphireTasks} />
          <Route path="/lift-dashboard/sapphire-completed" component={SapphireCompleted} />
          <Route path="/lift-history" component={LiftHistory} />
          <Route path="/user-profile" component={AccountSettings} />
          <Route path="/test-ui" component={TestUi} />
          <Route path="/all-notifications" component={ViewAllNotificationsTable} />
         
          {/* <ProtectedRoute
            path="/subscriptions"
            component={LiftSubscriptionRegistration}
          /> */}
           <Route
            path="/subscriptions"
            component={LiftSubscriptionRegistration}
          />
          <Route component={Error} />
          <Route
            path="/lift-forgot-password/:id"
            exact
            component={LiftForgotPassword}
          />
        </Switch>
      </div>
    </BrowserRouter>
  );
};


export default App;
